/**
 * Converts a string to PascalCase.
 *
 * @param {string} str - The string to convert.
 * @returns {string} The converted string in PascalCase.
 */
export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
